var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isInline)?_c('span',{class:_vm.classes,style:(_vm.styles)},[_vm._v("\n\t"+_vm._s(_vm.label)+"\n")]):_c('vnode-syringe',{attrs:{"class&":_vm.classes,"style&":_vm.styles}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }